export const environment = {
    production: false,
    apiUrl: 'https://pngtiapitest.clavisco.com/api/',
    name: 'Pan American GTI',
    env: 'Staging',
    recatchaSiteKey: '6Leso_QrAAAAAD7OHYr1dt3xsDmdt1xO9BALePG6',
    logrocket: ''
  }